import React, { FC } from 'react';
import { Box, Button, Typography, Stack } from '@mui/material';
import StarIcon from 'src/assets/icons/star.svg';
import MealPlanIcon from 'src/assets/icons/meal.svg';
import NoteIcon from 'src/assets/icons/note.svg';
import OnboardingImage from 'src/assets/images/onboardingQuiz.jpg';
import { useDispatch } from 'react-redux';
import { updateQuizData } from 'src/store/quiz';
import colors from 'src/styles/equalution/colors';

interface EquOnboardingProps {}

export const OnboardingReinforce: FC<EquOnboardingProps> = () => {
  const dispatch = useDispatch();

  const onQuizStart = () => {
    dispatch(updateQuizData({ currentStep: 3.2 }));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Box
        component="img"
        src={OnboardingImage}
        alt="Onboarding quiz illustration"
        width={'100%'}
        sx={{
          maxWidth: { xs: '100%', md: '600px' },
          objectFit: 'contain',
          marginBottom: '8px',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '-24px',
          display: 'block',
        }}
      />
      <Box
        sx={{
          flex: 1,
          px: 3,
          py: 4,
          maxWidth: '480px',
          alignSelf: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}>
        <Typography
          sx={{
            fontSize: '28px',
            fontWeight: 700,
            textAlign: 'left',
            lineHeight: 1.3,
          }}>
          Your{' '}
          <Box component="span" sx={{ color: colors.SALAD }}>
            equ
          </Box>{' '}
          journey is
          <br /> personalised around your unique goals.
        </Typography>

        <Stack spacing={3} mt={2}>
          <FeatureItem
            icon={MealPlanIcon}
            title="Personalised meal plans"
            text="We tailor meals to your preferences from a library of 10,000+ recipes."
          />
          <FeatureItem
            icon={NoteIcon}
            title="Track for success"
            text="We make daily food/water tracking seamless to hit your goals."
          />
          <FeatureItem
            icon={StarIcon}
            title="Real results"
            text="We've helped over 100,000+ people reach their goals."
          />
        </Stack>

        <Button
          variant="contained"
          onClick={onQuizStart}
          size="large"
          sx={{
            textTransform: 'none',
            borderRadius: '100px',
            marginTop: 4,
            width: '330px',
            height: '55px',
            alignSelf: 'center',
            marginBottom: 2,
          }}>
          Continue to quiz
        </Button>
      </Box>
    </Box>
  );
};

interface FeatureItemProps {
  icon: string;
  title: string;
  text: string;
}

const FeatureItem: FC<FeatureItemProps> = ({ icon, title, text }) => (
  <Stack direction="row" spacing={2} alignItems="flex-start">
    <img src={icon} alt="icon" />
    <Box>
      <Typography sx={{ fontWeight: 700, fontSize: '16px' }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: '14px', mt: 0.5 }}>{text}</Typography>
    </Box>
  </Stack>
);
